import ListItemTransfers from "../../../../components/@documents/item_transfers/ListItemTransfers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransfersPage() {

    return (
        <ListItemTransfers 
            routeType={routeTypes.retail}
        />
    )
}